import fetch from 'isomorphic-fetch';
import {actionUrls, actionTypes} from '../const';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {constants, moment} from '../containers/common/commonExport';
import { useDispatch, useSelector } from 'react-redux';
let postHeaders = constants.postHeaders;
let getHeaders = constants.getHeaders;

// let fetchController = null;

let notifyObj = {
    showNotification:true,
    notifyMessage:'Successfully Done'
}
var logout_timer;
var logout_interval;
var editmodeon_timer;
var editmodeon_timer_today;
export function hastusUpdate(post){
    return(dispatch) => {
        dispatch(actionHastus(post));
        
    }
}

function actionHastus(post){
    return {
        type:actionTypes.HASTUS_UPDATE,
        postdata:post
    }
}

function setDefaultWorkdaySuccess(workday){
    return {
        type:actionTypes.DEFAULTWORKDAY_SUCCESS,
        defaultWorkday:workday
    }
}
export function setDefaultWorkdayAction(workday){
    return (dispatch) => {
        dispatch(setDefaultWorkdaySuccess(workday));
    }
}
export function resetWorkdayAction(workday){
    var data = {
        errMsg:'',
        success:true
    }
    return (dispatch) => {
        dispatch(resetWorkdaySuccess(workday));
        dispatch(errInAddingWorkday(data));
        dispatch(activity_err_success(false, false, '', false));
        dispatch(changesOnActivitySuccess(false));
    }
}

function postInProgress(bool){
    return {
        type:actionTypes.POST_IN_PROGRESS,
        progress:bool
    }
}
function errInAddingWorkday(err){
    return {
        type:actionTypes.ERR_IN_ADD_WORKDAY,
        errMsg:err.errMsg,
        errStatus:!err.success
    }
}

export function closeSuccessPopAction(){
    return (dispatch) => {
        dispatch(addWorkdaySuccess(false));
    }
}
function addWorkdaySuccess(bool){
    return {
        type:actionTypes.ADD_WORKDAY_SUCCESS,
        success:bool,
        successMsg:'Submitted Successfully'
    }
}

function getNotesSuccess(notes){
    return {
        type:actionTypes.GET_NOTES_SUCCESS,
        notes:notes
    }
}
export function fetchNotes(url) {
    var uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        fetch(url + uniqueUrl,{
            method: 'GET',
            headers:getHeaders(token),
        })
            .then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                return response;
            })
           .then(response =>
                response.json().then(notes => ({ notes, response }))
                    ).then(({ notes, response }) =>  {
                if (!response.ok) {
                  // If there was a problem, we want to
                  // dispatch the error condition
                  return Promise.reject(notes)
                } else {
                    dispatch(getNotesSuccess(notes));
                }
              })
    };
}

export function hideNotesModal(){
    return {
        type:actionTypes.HIDE_NOTES_SUCCESS
    }
}
function getEAndDActivitiesSuccess(activity){
    return {
        type: actionTypes.E_AND_D_ACTIVITIES_SUCCESS,
        activity
    };
}
export function eAndDActivitiesAction(fetchObj, callback){
    var empId = fetchObj.id;
    var date = fetchObj.date;
    var url = actionUrls.E_AND_D_ACTIVITIES_URL + '/' + empId+  '/' + date + "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        fetch(url,{
            method: 'GET',
            headers:getHeaders(token),
        })
            .then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                if(callback){
                    callback(response);
                }
                return response;
            })
            .then((response) => response.json())
            .then((activity) => {
                dispatch(getEAndDActivitiesSuccess(activity));
                if(callback){
                    callback(activity);
                }
            })
    };
}
export function submitNoteAction(noteObj, callback){
    var url = actionUrls.POST_NOTE_URL + "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        fetch(url, {
                method: 'POST',
                headers:postHeaders(token),
                body: JSON.stringify(noteObj)
            })
            .then((response) => response.json())
            .then((data) => { 
                
                dispatch(notificationSuccess(notifyObj));
                setTimeout(function(){
                    dispatch(hideNotification())
                }, 3000);
                if(data.success) {
                    let fetchObj = {
                        role : 'emp',
                        url : "/workdays",
                        pageNum : 1,
                        empId : localStorage.getItem('empId'),
                        source: 'web'
                    }
                    dispatch(fetchWorkdays(fetchObj));
                    callback({success:true});
                }
            })
    };
}
export function submitWorkdayAction(workdayObj){
    var url = actionUrls.ADD_NEW_WORKDAY_URL + "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(postInProgress(true));
        dispatch(addWorkdaySuccess(false));
        fetch(url, {
                method: 'POST',
                headers:postHeaders(token),
                body: JSON.stringify(workdayObj)
            })
            .then((response) => response.json())
            .then((data) => { 
                dispatch(notificationSuccess(notifyObj));
                setTimeout(function(){
                    dispatch(hideNotification())
                }, 3000);
                dispatch(postInProgress(false));
                dispatch(errInAddingWorkday(data));
                if(data.success) {
                    dispatch(addWorkdaySuccess(true));
                    // dispatch(resetWorkday());
                } else {

                }
            })
    };
}
function getActivitiesSuccess(activities){
    return {
        type: actionTypes.ACTIVITIES_SUCCESS,
        activities: activities
    }
}
export function fetchActivities(url) {
    var uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        fetch(url + uniqueUrl,{
            method: 'GET',
            headers:getHeaders(token),
        })
            .then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                return response;
            })
           .then(response =>
                response.json().then(activities => ({ activities, response }))
                    ).then(({ activities, response }) =>  {
                if (!response.ok) {
                  // If there was a problem, we want to
                  // dispatch the error condition
                  return Promise.reject(activities)
                } else {
                    dispatch(getActivitiesSuccess(activities))
                }
              })
    };
}

/***** workdays actions (start) *****/
function workdaysIsLoading(bool) {
    return {
        type: actionTypes.ITEMS_IS_LOADING,
        isLoading: bool
    }
}
function workdaysHasErrored(bool) {
    return {
        type: actionTypes.ITEMS_HAS_ERRORED,
        hasErrored: bool
    }
}

export const workdaysFetchDataSuccess = (workdays) => (dispatch) => {  
    dispatch({
        type: actionTypes.ITEMS_SUCCESS,
        workdays: workdays.workdays,
        pageNum: workdays.pageNum,
        activities:workdays.activities,
        locations:workdays.locations
    })
    
    dispatch(roleSuccess(workdays));
    dispatch(paginationSuccess(workdays));
}

function auditFetchDataSuccess(auditData){
    return {
        type: actionTypes.ITEMS_SUCCESS,
        audtitData:auditData.workdays
    }
}
function locationsSuccess(locations){
    return {
        type: actionTypes.LOCATION_SUCCESS,
        locations:locations
    }
}
function closePopupSuccess(data){
    return {
        type: actionTypes.POPUP_MESSAGE_CLOSE,
        data:data
    };
}

function popupMessage(data) {
    // cons
    return {
        type: actionTypes.POPUP_MESSAGE,
        data: data,
    }
}
export function closePopupMessage(){
    return (dispatch) => {
        dispatch(closePopupSuccess({ show: false, message: '' }));
        localStorage.clear();
        dispatch(logoutSuccess());
        window.location.href = '#/';
    };
}
function manageError(dispatch, response){
    response.json().then(res => {
        if(res.success == false && res.type == "unauthorized"){
            let msg = res.message;
            showlogoutpopup(dispatch,msg);
        }        
    });
}
function showlogoutpopup(dispatch, message) {
    dispatch(popupMessage({ 
        show: true, 
        message: message
    }));
    setTimeout(() => {
        dispatch(closePopupMessage());
    }, 10000); 
}

export function fetchWorkdays(fetchObj, callback) {   
    // if(fetchController != null){
    //     fetchController.abort();
    //     fetchController = null;
    // }
    // fetchController = new AbortController();

    let route = fetchObj.route ? fetchObj.route:undefined;
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(printProgress(false));
        dispatch(coverLoading(true));
        dispatch(showLoading());
        dispatch(workdaysIsLoading(true));
        
        fetch(url + uniqueUrl, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(fetchObj),
            // signal: fetchController.signal
        }).then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(workdaysIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                return response;
            })
           .then(response =>
                response.json().then(items => ({ items, response }))
                    ).then(({ items, response }) =>  {
                if (!response.ok) {
                  // If there was a problem, we want to
                  // dispatch the error condition
                  dispatch(workdaysIsLoading(false));
                  dispatch(hideLoading());
                  return Promise.reject(items)
                } else {
                    if(route == constants.AUDIT_TRAIL){
                        dispatch(auditFetchDataSuccess(items));
                    } else {
                     
                        dispatch(workdaysFetchDataSuccess(items));
                        if(fetchObj.isRefresh === true && Array.isArray(items.workdays) && items.workdays.length > 0 
                            && items.workdays[0].refreshed_time && items.workdays[0].wdy_time_start && items.workdays[0].wdy_time_end){
                            let shiftTiming = {
                                server_time : items.workdays[0].server_time,
                                wdy_time_start:items.workdays[0].wdy_time_start,
                                wdy_time_end:items.workdays[0].wdy_time_end
                            };
                            updateAppModeOnRefresh(dispatch,shiftTiming);
                        }
                    }
                    dispatch(hideLoading());
                    dispatch(coverLoading(false));
                    if(callback){
                        callback(items);
                        //console.log('items'+items)
                    }                    
                }
            })
            .catch(err => {
                console.log(err);
                dispatch(hideLoading());
                dispatch(workdaysIsLoading(false));
                dispatch(coverLoading(false));
            });
    };
}

function hideNotification(){
    let notifyObj = {
        showNotification:false,
        notifyMessage:''
    }
    return {
        type:actionTypes.NOTIFICATION_SUCCESS,
        notifyObj:notifyObj
    }
}
/***** workdays actions (end) *****/


/***** workday actions (start) *****/
function workdayIsLoading(bool) {
    return {
        type: actionTypes.WORKDAY_LOADING,
        isLoading: bool
    }
}
function getWorkdaySuccess(workday) {
    return {
        type: actionTypes.WORKDAY_SUCCESS,
        workday
    };
}
export function initilizeWorkday() {
    return (dispatch,getState) => {
        dispatch(workdaysIsLoading(true));
    }
}
// edit workday
function editActivitySuccess(duty_id) {
    return {
        type: actionTypes.EDIT_SUCCESS,
        duty_id
    }
}
function resetWorkdaySuccess(workday) {
    return {
        type: actionTypes.RESET_WORKDAY_SUCCESS,
        workday
    }
}
export function getWorkdayAction(url, callback) {
    var url = url + "?_= " + new Date().getTime();
    
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(workdayIsLoading(true));
        dispatch(showLoading());
        fetch(url,{
            method: 'GET',
            headers:getHeaders(token),
        })
            .then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(workdayIsLoading(false));
                dispatch(hideLoading());
                if(callback){
                    callback(response);
                }
                return response;
            })
            .then((response) => response.json())
            .then((workday) => {
                dispatch(getWorkdaySuccess(workday));
                dispatch(hideLoading());
                if(callback){
                    callback(workday);
                }
            })
    };
}

export function editActivityAction(duty_id) {
    return (dispatch) => {
        dispatch(editActivitySuccess(duty_id))
    };
}

export function editAllActivityAction(){
    return (dispatch)=>{
        dispatch(editActivitySuccess())
    }
}

function filterSuccess(filterObj){
    return {
        type: actionTypes.FILTER_SUCCESS,
        filterObj:filterObj
    }
}
export function filterAction(filterObj, callback){
    return (dispatch) => {
        dispatch(filterSuccess(filterObj));
        if(callback){
            callback(filterObj);
        }
    }
}

function resetFilterSuccess(resetFilterObj){
    return {
        type: actionTypes.RESET_FILTER_SUCCESS,
        filterObj:resetFilterObj
    }
}
export function resetFilterAction(filterObj, callback){
    return (dispatch) => {
        dispatch(resetFilterSuccess(filterObj)); 
        if(callback){    
            callback(filterObj);   
        }
    }
}
// delete workday
function deleteActivitySuccess(duty_id) {
    return {
        type: actionTypes.DELETE_SUCCESS,
        duty_id
    }
}

function changesOnActivitySuccess(bool) {
    return {
        type: actionTypes.CHANGES_SUCCESS,
        changesInActivity: bool
    }
}

export function changesInActivityAction(bool){
    return (dispatch) => {
        dispatch(changesOnActivitySuccess(bool))
    };
}

export function deleteActivityAction(duty_id) {
    return (dispatch) => {
        dispatch(deleteActivitySuccess(duty_id))
    };
}

function addActivitySuccess() {
    return {
        type: actionTypes.ADD_SUCCESS
    }
}
export const addActivityAction = (addedtype) => (dispatch) => {
    dispatch({
        type: actionTypes.ADD_SUCCESS,
        actName:addedtype
    })
}

function activityChangeInProgress(value, property, duty_act_key, rawTime){
    return {
        type: actionTypes.UPDATE_SUCCESS,
        updatedActObj: {
            values: value,
            property: property,
            duty_act_key: duty_act_key,
            rawTime:rawTime
        }
    }
}

export function changeActivityAction(value, property, duty_act_key, rawTime){
    return (dispatch) => {
        dispatch(activityChangeInProgress(value, property, duty_act_key, rawTime));
    }    
}

function activity_err_success(errpopup, acterr, errMessage, certifyError, latestRecords){
    return {
        type: actionTypes.ACTIVITY_ERR_SUCCESS,
        activityErrPopup:errpopup,
        activityErr:acterr,
        activityErrMessage: errMessage,
        latestRecords:latestRecords == false ? latestRecords : true,
        certifyError: certifyError
    }
}
export function actErrorAction(errpopup, acterr, errMessage, latestRecords){ // errpopup, acterr
  return (dispatch) => {
        dispatch(activity_err_success(errpopup, acterr, errMessage, false, latestRecords));
    }
}

function setActivityErr_Success(act_key, bool){
    return {
        type: actionTypes.SET_ACTIVITYERR_SUCCESS,
        duty_act_key:act_key,
        duty_act_status:bool
    }
}
export function setActivityErrAction(act_key, bool){
    return (dispatch) => {
        dispatch(setActivityErr_Success(act_key, bool));
    }
}
/***** workday actions (end) *****/

/***** pagination actions (start) *****/
function paginationSuccess(paginationObj) {
    return {
        type: actionTypes.PAGINATION_SUCCESS,
        paginationObj: paginationObj
    };
}
/***** pagination actions (end) *****/

/***** role actions (start) *****/
function roleSuccess(roleObj) {
    return {
        type: actionTypes.ROLE_SUCCESS,
        role: roleObj.role,
        route: roleObj.route
    }
}
/***** role actions (end) *****/

/***** modal actions (start) *****/
function showModal_Success(bool, modalName, action) {
    return {
        type: actionTypes.SHOWMODAL_SUCCESS,
        showModal: bool,
        modalName: modalName,
        action: action ? action :''
    }
}
export function showModalAction(modalName, action) {
    return (dispatch) => {
        dispatch(showModal_Success(true, modalName, action));
    }
}
export function showModalUpdateManual(id) {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SHOWMODAL_MANUAL,
            id_manual: id
        });
    };
}

function setNotes_Success(notesObj){
    return {
        type:actionTypes.SET_NOTES_SUCCESS,
        notesObj:notesObj
    }
}
export function setNotesObj(notesObj){
    return (dispatch) => {
        dispatch(setNotes_Success(notesObj));
    }
}
function hideModal_Success(bool, modalName) {
    return {
        type:actionTypes.HIDEMODAL_SUCCESS,
        showModal: bool,
        modalName: modalName
    }
}
export function hideModalAction(bool, modalName) {
    return (dispatch) => {
        dispatch(hideModal_Success(bool, modalName));
        dispatch(hideDeadheadWarning());
    }
}
/***** modal actions (end) *****/

/***** login actions (start) */
function loginSuccess(user){

    return {
        type: actionTypes.LOGIN_SUCCESS,
        authenticated:true,
        role:user.role,
        id_token: user.id_token,
        api_token: user.api_token,
        name:user.name,
        employeeID:user.employeeID,
        impersonateUserId:user.impersonateUserId,
        activeMenus : Array.isArray(user.activeMenus) ? user.activeMenus : [],
        isSystemAdmin:user.isSystemAdmin,
        userId:user.userId
    }


}

function loginInProgress(bool){
    return{
        type:actionTypes.LOGIN_PROGRESS,
        loginProgress:bool
    }
}

function loginError(errmsg){
    return {
        type: actionTypes.LOGIN_ERROR,
        loginErrMsg:errmsg,
        loginProgress:false
    }
}
export function loginAction(state, message) {

    return (dispatch,getState) => {

        if(state == "LoginProgress"){
            dispatch(loginInProgress(true));
        } else if(state == "LoginError"){
            dispatch(loginInProgress(false));

            dispatch(loginError(message));
            localStorage.clear();
        } else if(state == "LoginSuccess"){
            
            dispatch(loginSuccess(message));
            
            //var menuActive = search(1, message.activeMenus);
            if(message.role == "Employee"){
                getShiftTiming(dispatch,getState,message.employeeID);
            }
        }
    };
}


function search(nameKey, array){
	let exist = false;
    for (var i=0; i < array.length; i++) {
        if (array[i].MenuType === nameKey) {
            exist = true;
        }
    }
    return exist;
}

function logoutSuccess(){
    if(logout_timer){
        clearTimeout(logout_timer);
    } 
    if(logout_interval){
        clearInterval(logout_interval);
    }
    return {
        type:actionTypes.LOGOUT_SUCCESS,
        authenticated:false,
        role:'',
        id_token:'',
        api_token:'',
        name:'',
        employeeID:'',
    }
}

export function logoutAction(){
    return (dispatch, getState) => {
        const state = getState();
        if(state.authState.publicClient){
            state.authState.publicClient.logout();
        }
        localStorage.clear();
        dispatch(logoutSuccess());
        window.location.href = '#/';
    }
}

/***** login actions (end) */

export function onRecertifyAction(workdayId){
    
    var url = actionUrls.RECERTIFY_WORKDAY_URL + "?_= " + new Date().getTime(),
    workdayObj = {
        workdayId : workdayId
    }
    return (dispatch, getState) => {
        const state = getState();
        let certifyUserName = state.authState.name;
        const token = state.authState.api_token;
        workdayObj.certifyUserName = certifyUserName;
        fetch(url, {
                method: 'POST',
                headers:postHeaders(token),
                body: JSON.stringify(workdayObj)
            })
            .then((response) => response.json())
            .then((data) => { 
                if(data.success) {
                    dispatch(notificationSuccess(notifyObj));
                    setTimeout(function(){
                        dispatch(hideNotification())
                    }, 3000);
                    dispatch(hideModal_Success(false, ''));             
                        let fetchObj = {};
                        fetchObj.role = 'emp';
                        fetchObj.url = "/workdays";
                        fetchObj.pageNum = 1;  
                        fetchObj.empId = localStorage.getItem('empId');
                        fetchObj.source = 'web';      
                        dispatch(fetchWorkdays(fetchObj));
                }
            }) .catch((error) => {
                console.log(error);
              });
    };
}

function workdayToggledSuccess(bool){
    return {
        type:actionTypes.WORKDAY_TOGGLED_SUCCESS,
        toggledState:bool
    }
}
export function toggleWorkdayAction(bool){
    return (dispatch) => {
        dispatch(workdayToggledSuccess(bool));
    }
}
function tabChangeSuccess(key){
  return {
        type:actionTypes.TAB_CHANGE_SUCCESS,
        changedState:key
    }  
}
export function tabChangeAction(key){
    return (dispatch) => {
        dispatch(tabChangeSuccess(key));
    }
}
function actionInProcess(bool){
    return {
        type:actionTypes.ACTION_INPROCESS,
        actionInProcess:bool
    }
}
export function onCertifyAction(workdayId, workday, comments, changes, role, certifyByAdminState){
    
    let certifyByAdmin = certifyByAdminState ? certifyByAdminState : false;
    var url = actionUrls.POST_WORKDAY_URL + "?_= " + new Date().getTime();
    var role = role ? role : '', wdy_time_end=workday.wdy_time_end, wdy_date=workday.wdy_date;
    var currentPageNum = 1,
        workdayObj;
        var prevComments = workday.wdy_comments == "NULL" ? "" : workday.wdy_comments ;
        var totalTOS = workday.wdy_spread_adjust,
            totalHOS = workday.wdy_working_time_hos_adjust;
        if(changes){
        workdayObj = {
            certifyByAdmin:certifyByAdmin,
            duty_activity:workday.duty_activity,
            changes:changes,
            workdayId:workdayId,
            wdy_spread_adjust : totalTOS,
            wdy_working_time_hos_adjust : totalHOS,
            wdy_time_end:wdy_time_end,
            wdy_date:wdy_date
        }
    } else {
        workdayObj = {
            certifyByAdmin:certifyByAdmin,
            changes: changes,
            workdayId: workdayId,
            role: role,
            demp_display_id:workday.demp_display_id,
            duty_activity: workday.duty_activity,
            wdy_spread_adjust : totalTOS,
            wdy_working_time_hos_adjust : totalHOS,
            wdy_time_end:wdy_time_end,
            wdy_date:wdy_date,
            dutyActivityStatus:workday.dutyActivityStatus
        }
    }
    
    let commentTime = moment().format('L') + " " + moment().format('LT');
    return (dispatch, getState) => {
        const state = getState();        
        let adminUserName =  state.authState.userName.split('@');       
        let certifyUserName = state.authState.impersonateUserId>0?  adminUserName[0].replace('.',' '):state.authState.name;
        const token = state.authState.api_token;
        workdayObj.certifyUserName = certifyUserName;
        if(comments.value){
            workdayObj.comments = prevComments + " " + certifyUserName + " (" + commentTime + ")" + " ^- " + comments.value + "~";
        }
        else{
            workdayObj.comments = '';
        }
        if(workdayObj.duty_activity){
            
        let dutyActivity = workdayObj.duty_activity;
            let adjustedActivity = dutyActivity.map(activity => {
                if(activity.dty_act_end_time){
                   activity.dty_act_end_time =  activity.dty_act_end_time.toUpperCase();
                }
                if(activity.dty_act_start_time){
                   activity.dty_act_start_time = activity.dty_act_start_time.toUpperCase();
                }
                if(activity.dty_act_end_time_updated){
                   activity.dty_act_end_time_updated =  activity.dty_act_end_time_updated.toUpperCase();
                   activity.dty_act_end_time_raw_updated =  activity.dty_act_end_time_raw;
                }
                if(activity.dty_act_start_time_updated){
                   activity.dty_act_start_time_updated = activity.dty_act_start_time_updated.toUpperCase();
                   activity.dty_act_start_time_raw_updated =  activity.dty_act_start_time_raw;
                }              
                if(activity.dty_adjusted_value_updated == null || activity.dty_adjusted_value_updated == "00:00"){
                    activity.dty_adjusted_value_updated = "0:00"
                }
                if(activity.dty_adjusted_value == "00:00"){
                    activity.dty_adjusted_value = "0:00"
                }
            })
            workdayObj.duty_activity = dutyActivity;
        }      
        dispatch(actionInProcess(true));
        fetch(url, {
                method: 'POST',
                headers:postHeaders(token),
                body: JSON.stringify(workdayObj)
            })
            .then((response) => response.json())
            .then((data) => { 
                let fetchObj = {};
                if(data.success) {
                    dispatch(notificationSuccess(notifyObj));
                    setTimeout(function(){
                        dispatch(hideNotification())
                    }, 3000);
                    dispatch(actionInProcess(false));
                    let fetchObj = {
                        empId:localStorage.getItem('empId'),
                        pageNum:1,
                        role:"emp",
                        url:"/adminworkdays",
                        certifyStatus:localStorage.getItem('route')
                    }
                    dispatch(hideModal_Success(false, ''));
                    if(role == constants.roles.ADMIN_ROLE){
                        fetchObj.role = constants.roles.ADMIN_ROLE;
                        fetchObj.url = "/adminworkdays";
                        fetchObj.certifyStatus =localStorage.getItem('route');
                        fetchObj.pageNum = 1;
                        dispatch(fetchWorkdays(fetchObj));
                    } else {
                        fetchObj.role = 'emp';
                        fetchObj.url = "/workdays";
                        fetchObj.source = 'web';
                        fetchObj.pageNum = 1;  
                        fetchObj.empId = localStorage.getItem('empId');      
                        dispatch(fetchWorkdays(fetchObj));
                    }
                } else {
                    dispatch(activity_err_success(true, false, data.errMsg, true ));
                    dispatch(actionInProcess(false));
                }
            }) .catch((error) => {
                console.log(error);
                dispatch(actionInProcess(false));
              });
    };
}



//Action on updating the user, date and time fields in Database
export function hastusUpdateAction(hid, hastusdempId, hastusUser, hastusTime, hastusDate){
    
    var url = actionUrls.POST_WORKDAY_URL + "?_= " + new Date().getTime();
    var demp_display_Id = hastusdempId,lst_updt_user =hastusUser,updated_time=hastusTime,updated_date=hastusDate,id=hid;
            
            var workdayObj = {};
            workdayObj.demp_display_Id=demp_display_Id;
            workdayObj.lst_updt_user=lst_updt_user;
            workdayObj.updated_time=updated_time;
            workdayObj.updated_date=updated_date;
            workdayObj.id=id;

    return (dispatch, getState) => {
        const token = getState().authState.api_token;
        dispatch(actionInProcess(true));
        fetch(url, {
                method: 'POST',
                headers:postHeaders(token),
                body: JSON.stringify(workdayObj)
            })
            .then((response) => response.json())
            .then((data) => { 
                if(data.success) {
                    dispatch(notificationSuccess(notifyObj));
                    setTimeout(function(){
                        dispatch(hideNotification())
                    }, 3000);
                    dispatch(actionInProcess(false));
                    let fetchObj = {
                        url:constants.actionUrls.ADMIN_URL,
                        role: constants.roles.ADMIN_ROLE,
                        certifyStatus: constants.MANUALLY_UPDATE,
                        pageNum:1
                    }
                    dispatch(hideModal_Success(false, ''));
                    dispatch(fetchWorkdays(fetchObj));
                } else {
                    dispatch(activity_err_success(true, false, data.errMsg, true ));
                    dispatch(actionInProcess(false));
                }
            }) .catch((error) => {
                console.log(error);
                dispatch(actionInProcess(false));
              });
    };
}


export function onRejectClaimAction(workdayId, role, rejectStatus, cmts, workday) {
    var url = actionUrls.POST_WORKDAY_URL + "?_= " + new Date().getTime();
    var prevComments = workday.wdy_comments == "NULL" ? "" : workday.wdy_comments ;
    var workdayObj = {
        workdayId: workdayId,
        role: role,
        rejectStatus: rejectStatus,
        duty_activity:workday.duty_activity,
        certifyByAdmin: false
    };
    let commentTime = moment().format('L') + " " + moment().format('LT');
    return (dispatch, getState) => {
        const state = getState();
        const token = state.authState.api_token;
        let certifyUserName = state.authState.name;
        workdayObj.certifyUserName = certifyUserName;
        workdayObj.comments = prevComments + " " + certifyUserName + " (" + commentTime + ")" + " ^- " + cmts.value + "~";
        dispatch(actionInProcess(true));
        fetch(url, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(workdayObj)
        })
        .then((response) => response.json())
        .then((data) => { 
            if(data.success) {
                dispatch(actionInProcess(false));
                let fetchObj = {};
                dispatch(notificationSuccess(notifyObj));
                setTimeout(function(){
                    dispatch(hideNotification())
                }, 3000);
                dispatch(hideModal_Success(false, ''));
                if(role == constants.roles.ADMIN_ROLE){
                    fetchObj.role = constants.roles.ADMIN_ROLE;
                    fetchObj.url = "/adminworkdays";
                    fetchObj.certifyStatus =localStorage.getItem('route');
                    fetchObj.pageNum = 1;
                    dispatch(fetchWorkdays(fetchObj));
                }
            }
        })
    };
}

function dataToPrintSuccess(items){
    return {
        type:actionTypes.GETPRINTDATA_SUCCESS,
        data:items
    }
}
function printProgress(printStatus){
    return {
        type:actionTypes.PRINT_PROGRESS,
        printStatus:printStatus
    }
}
export function printProgressAction(printStatus){
    return (dispatch) => {
        dispatch(printProgress(printStatus));
    }
}

function coverLoading(coverStatus){
    return {
        type:actionTypes.COVER_LOADING,
        coverStatus:coverStatus
    }
}
export function coverLoadingAction(coverStatus){
    return (dispatch) => {
        dispatch(coverLoading(coverStatus));
    }
}

export function fetchDataToPrintAction(fetchObj, callback) {   


    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(printProgress(true));
        fetch(url + uniqueUrl, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(fetchObj)
        }).then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(printProgress(false));
                return response;
            })
           .then(response =>
            
                response.json().then(items => ({ items, response }))
                    ).then(({ items, response }) =>  {
                if (!response.ok) {
                  // If there was a problem, we want to
                  // dispatch the error condition
                  //dispatch(printProgress(false));
                  return Promise.reject(items)
                } else {
                    dispatch(dataToPrintSuccess(items));
                    if(callback){

                        callback(items.workdays);
                    }
                    //dispatch(printProgress(false));                    
                }
              })
    };
}

function notificationSuccess(notifyObj){
    return {
        type:actionTypes.NOTIFICATION_SUCCESS,
        notifyObj:notifyObj
    }
}
export function notifyAction(notifyObj){    
    return (dispatch) => {
        dispatch(notificationSuccess(notifyObj));
        setTimeout(function(){
            dispatch(hideNotification())
        }, 3000);
    }

    

}

//methods for NCNP

export function fetchWorkdaysNCNP(fetchObj, callback) {   
    let route = fetchObj.route ? fetchObj.route:undefined;
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
        
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(printProgress(false));
        dispatch(showLoading());
        dispatch(workdaysIsLoading(true));
        fetch(url + uniqueUrl, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(fetchObj)
        }).then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(workdaysIsLoading(false));
                dispatch(hideLoading());
                return response;
            })
           .then(response =>
                response.json().then(items => ({ items, response }))
                    ).then(({ items, response }) =>  {
                if (!response.ok) {
                  // If there was a problem, we want to
                  // dispatch the error condition
                  dispatch(workdaysIsLoading(false));
                  dispatch(hideLoading());
                  return Promise.reject(items)
                } else {
                    if(route == constants.AUDIT_TRAIL){
                        dispatch(auditFetchDataSuccess(items));
                    } else {
                        dispatch(workdaysFetchDataSuccess(items));
                    }
                    dispatch(hideLoading());
                    if(callback){
                        callback(items);
                        //console.log('items'+items)
                    }                    
                }
              })
    };
}

function configurationsFetchDataSuccess(data){
    let status = data.find((p) => p.PropertyName == "ncnpstatus");
    let days = data.find((p) => p.PropertyName == "ncnpdays");
    return {
        type: actionTypes.CONFIGURATION_SUCCESS,
        ncnpstatus : status ? status.PropertyValue : '0',
        ncnpDays : days ? days.PropertyValue : '0'
    };
}
export function fetchconfigurations(fetchObj, callback) { 
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(showLoading());
        fetch(url + uniqueUrl,{
            method: 'GET',
            headers:getHeaders(token),
        })
        .then((response) => {
            if (!response.ok) {
                manageError(dispatch, response);
                throw Error(response.statusText);
            }
            dispatch(hideLoading());
            return response;
        })
        .then(response => response.json().then(items => ({ items, response })))
        .then(({ items, response }) =>  {
            if (!response.ok) {
                // If there was a problem, we want to
                // dispatch the error condition
                dispatch(hideLoading());
                return Promise.reject(items);
            } else {
                dispatch(configurationsFetchDataSuccess(items));
                if(callback){
                    callback(items);
                }                    
            }
        });
    };
}

function ncnpChange(status, ncnpDays){
    return {
        type: actionTypes.CHANGE_CONFIGURATION,
        ncnpstatus : status, ncnpDays: ncnpDays
    };
}

export function changeNCNPStatus(status, ncnpDays){
    return (dispatch) => {
        dispatch(ncnpChange(status, ncnpDays));
    };    
}

export function submitConfigurationAction(confObj, callback){
    var url = actionUrls.UPDATE_CONFIGURATION_URL + "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        fetch(url, {
                method: 'POST',
                headers:postHeaders(token),
                body: JSON.stringify(confObj)
            }
        )
        .then((response) => response.json())
        .then((data) => { 
            if(data.success) {
                dispatch(ncnpChange(confObj.ncnpstatus, confObj.ncnpDays));
                dispatch(notificationSuccess(notifyObj));
                setTimeout(function(){
                    dispatch(hideNotification());
                }, 3000);
                callback({success:true});
            }
        });
    };
}

//to get hos logs for admin
export function fetchhoslogsWorkdays(fetchObj, callback) {

    let route = fetchObj.route ? fetchObj.route:undefined;
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(coverLoading(true));
        dispatch(printProgress(false));
        dispatch(showLoading());
        dispatch(workdaysIsLoading(true));

        fetch(url + uniqueUrl, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(fetchObj),
            // signal: fetchController.signal
        }).then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(workdaysIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                return response;
            })
           .then(response =>
                response.json().then(items => ({ items, response }))
                    ).then(({ items, response }) =>  {
                if (!response.ok) {
                  // If there was a problem, we want to
                  // dispatch the error condition
                  dispatch(workdaysIsLoading(false));
                  dispatch(hideLoading());
                  dispatch(coverLoading(false));
                  return Promise.reject(items)
                } else {

                    if(route == constants.AUDIT_TRAIL){
                        dispatch(auditFetchDataSuccess(items));
                    }
                    else if(route==constants.HISTORICAL_LOGS) 
                    {
                        dispatch(hoslogFetchDataSuccess(items));
                    }                    
                    else {
                       
                        dispatch(hoslogFetchDataSuccess(items));
                        
                        if(fetchObj.isRefresh === true && Array.isArray(items.workdays) && items.workdays.length > 0 
                            && items.workdays[0].refreshed_time && items.workdays[0].wdy_time_start && items.workdays[0].wdy_time_end){
                            let shiftTiming = {
                                server_time : items.workdays[0].server_time,
                                wdy_time_start:items.workdays[0].wdy_time_start,
                                wdy_time_end:items.workdays[0].wdy_time_end,
                                wdy_Certify_status:items.workdays[0].wdy_certify_status
                            };
                            
                            updateAppModeOnRefresh(dispatch,shiftTiming);
                        }
                        
                        let timeNow = moment().format('MM/DD/YYYY') ;
                        if(items.workdays[0].wdy_certify_status=='C' && items.workdays[0].wdy_date ==timeNow)
                        {
                           
                            dispatch(setAppEditmode(false));
                            dispatch(setAppEditmode_fortoday(false));
                        }
                    }
                    dispatch(hideLoading());
                    dispatch(coverLoading(false));
                    if(callback){
                        callback(items);
                        //console.log('items'+items)
                    }                    
                }
            })
            .catch(err => {
                console.log(err);
                dispatch(workdaysIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
            });
    };
}
function updateAppModeOnRefresh(dispatch,shiftTiming){

    let shiftTime =  moment(shiftTiming.wdy_time_end,'YYYY-MM-DD HH:mm');
    setTimerForEditModeOff(dispatch,shiftTiming.server_time,shiftTime);

    if(shiftTiming.server_time && shiftTime){
        
        dispatch(updateServerTime(shiftTiming.server_time));
        checkAppEditmode(dispatch,shiftTiming);
    }
    else{

        
        dispatch(setAppEditmode(false));
    }
}
export const hoslogFetchDataSuccess = (workdays) => (dispatch) => {  

    dispatch({
        type: actionTypes.ITEMS_SUCCESS,
        workdays: workdays.workdays,
        pageNum: workdays.pageNum,
        activities:workdays.activities,
        locations:workdays.locations
    })
    //TODO : should get role and route from sp for rolesuccess
    dispatch(roleSuccess(workdays));
    dispatch(paginationSuccess(workdays));
}


//to get hos logs details for particular log
export function getLogDetailsAction(url, callback) {
    var url = url + "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(workdayIsLoading(true));
        dispatch(showLoading());
        fetch(url,{
            method: 'GET',
            headers:getHeaders(token),
        })
        .then((response) => {
            if (!response.ok) {
                manageError(dispatch, response);
                throw Error(response.statusText);
            }
            dispatch(workdayIsLoading(false));
            dispatch(hideLoading());
            if(callback){
                callback(response);
            }
            return response;
        })
        .then((response) => response.json())
        .then((workday) => {
            dispatch(getWorkdaySuccess(workday));
            dispatch(hideLoading());
            if(callback){
                callback(workday);
            }
        })
    };
}

//Get shift timing
function getShiftTiming(dispatch,getState,empID) {
    var url_main = constants.actionUrls.SHIFT_TIMING + "/" + empID + "?_= " + new Date().getTime();
    const token = getState().authState.api_token;

    fetch(url_main,{
        method: 'GET',
        headers:getHeaders(token),
    })
    .then((response) => {
        if (!response.ok) {
            manageError(dispatch, response);
            throw Error(response.statusText);
        }
        return response.json();
    })
    .then((shiftTiming) =>  {

        let shiftTime =  moment(shiftTiming.wdy_time_end,'YYYY-MM-DD HH:mm');
        setTimerForEditModeOff(dispatch,shiftTiming.server_time,shiftTime);
        
        if(shiftTiming.server_time && shiftTime){
            dispatch(updateServerTime(shiftTiming.server_time));
            checkAppEditmode(dispatch,shiftTiming);
        }
        else{

            
            dispatch(setAppEditmode(false));
        }
    });
}
function checkAppEditmode(dispatch,shiftTiming){
    const startTime = moment(shiftTiming.wdy_time_start,'YYYY-MM-DD HH:mm');    
    const endTime = moment(shiftTiming.wdy_time_start,'YYYY-MM-DD HH:mm').add(18, 'hours');
    const timeNow = moment(shiftTiming.server_time,'YYYY-MM-DD HH:mm:ss');
    const isBet = timeNow.isBetween(startTime, endTime);
    const isBef = timeNow.isBefore(startTime);

    if((isBet===true) && (shiftTiming.hos_certify_status.trim().toUpperCase() ===constants.CERTIFIED.trim().toUpperCase()))
    {
        
        dispatch(setAppEditmode(false));
        dispatch(setAppEditmode_fortoday(false));
    }else if(isBet) {        
       
        dispatch(setAppEditmode(true)); //true : edit mode on        
        const startTime_today =endTime.subtract(18, 'hours');
        let diffInSecs = startTime_today.diff(timeNow,'seconds');
        
        if(diffInSecs > 0){
            if(editmodeon_timer_today){
                clearTimeout(editmodeon_timer_today);
            }
            editmodeon_timer_today = setTimeout(() => {
                
                dispatch(setAppEditmode_fortoday(true));
            }, diffInSecs * 1000); 
        }
        else{
            
            dispatch(setAppEditmode_fortoday(true));
        }
    }
    else if(isBef){

        const onEditTime = startTime.format('MM/DD/YYYY HH:mm');
        dispatch(setAppEditmode(false,onEditTime));
        dispatch(setAppEditmode_fortoday(false));

        //set timer to make edit mode on
        let diffInSecs = startTime.diff(timeNow,'seconds');
        if(editmodeon_timer){
            clearTimeout(editmodeon_timer);
        }
        editmodeon_timer = setTimeout(() => {
            
            dispatch(setAppEditmode(true));
        }, diffInSecs * 1000); 
    }
    else{

        dispatch(setAppEditmode(false));
        dispatch(setAppEditmode_fortoday(false));
    }
}
function setTimerForEditModeOff(dispatch,serverTime,shiftTime){
    if(serverTime && shiftTime)
    {
        let momTimeNow = moment(serverTime,'YYYY-MM-DD HH:mm:ss');
        //user should see timer after 1 min of shift time end, for 2 min countdown 
        let shiftTimeCopy = moment(shiftTime);
        let momShiftTime = shiftTime.add(1, 'minutes');
        if(momTimeNow < shiftTimeCopy.add(3, 'minutes')){
            //Diff between shift time post 1 min and current time in milis
            let diffInSecs = momShiftTime.diff(momTimeNow,'seconds') ; 
            
            let counterSecs = diffInSecs < 0 ? diffInSecs + 120 : 120;
            let timeoutSecs = diffInSecs < 0 ? 0 : diffInSecs;
            
            if(logout_timer){
                clearTimeout(logout_timer);
            }
            logout_timer = setTimeout(() => {
                startCountdown(counterSecs,dispatch);
            }, timeoutSecs * 1000); 
        }
    }
}
function startCountdown(counter,dispatch){
    if(logout_interval){
        clearInterval(logout_interval);
    }
    logout_interval = setInterval(() => {
      counter--;
      dispatch({
        type: actionTypes.SHOW_LOGOUT_TIMER,
        showTimer : true,
        timerSecs : counter
      });
      if(counter == 0 ){
        dispatch(closeCountdownTimer());
        //showlogoutpopup(dispatch,'');
        dispatch(setAppEditmode(false)); 
        clearInterval(logout_interval);
      }
    }, 1000);
}
function setAppEditmode(mode,timeleft = '') {
    //mode = true : edit mode on
    return {
        type: actionTypes.OFFDUTY_CHECK,
        isOffDutyLoggedin : mode,
        editModeOnTime : timeleft
    }; 
}
function setAppEditmode_fortoday(mode) {
    //mode = true : edit mode on
    return {
        type: actionTypes.OFFDUTY_CHECK_FOR_TODAY,
        isOnDutyLoggedinForToday : mode
    }; 
}
function updateServerTime(time) {
    return {
        type: actionTypes.UPDATE_SERVER_TIME,
        server_time : time
    }; 
}
function updateActiveMenus(menus) {
    return {
        type: actionTypes.UPDATE_ACTIVE_MENU,
        active_menus : menus
    }; 
}
function closeCountdownTimer() {
    return {
        type: actionTypes.CLOSE_LOGOUT_TIMER,
        showTimer : false,
        timerSecs : 0
    }; 
}
function workdayActivityLogs(property,value){
    return {
        type: actionTypes.UPDATE_WORKDAY_LOG_SUCCESS,
        updatedWorkdayObj: {
            value: value,
            property: property
        }
    }
}

export function changeWorkdayActivityLogs(property,value){
    return (dispatch) => {
        dispatch(workdayActivityLogs(property,value));
        dispatch(changesOnActivitySuccess(true));
    }    
}
export function onCertifyHOSLogAction(inputParam) {

    let workdayId = inputParam.workdayId , workday =inputParam.workday, comments = inputParam.cmts, changes= inputParam.changes
    , role=inputParam.role?inputParam.role:'', certifyByAdminState=inputParam.certifyByAdmin,isSave=inputParam.isHosSave,
    userId= inputParam.userId;
    let certifyByAdmin = certifyByAdminState ? certifyByAdminState : false;
    var url = actionUrls.POST_HOSLOG_WORKDAY_URL + "?_= " + new Date().getTime();
    var wdy_time_end=workday.wdy_time_end, wdy_date=workday.wdy_date;
    var currentPageNum = 1,
        workdayObj;
        var prevComments = workday.wdy_comments == "NULL" ? "" : workday.wdy_comments ;
        var totalTOS = workday.wdy_spread_adjust == null ? workday.wdy_spread : workday.wdy_spread_adjust,
            totalHOS = workday.wdy_working_time_hos_adjust == null ? workday.wdy_working_time_hos : workday.wdy_working_time_hos_adjust;
    if(changes){
        workdayObj = {
            certifyByAdmin:certifyByAdmin,
            duty_activity:workday.duty_activity,
            changes:changes,
            workdayId:workday.WorkDay_Id,
            role: role,
            wdy_spread_adjust : totalTOS,
            wdy_working_time_hos_adjust : totalHOS,
            wdy_time_end:wdy_time_end,
            wdy_date: wdy_date,
            isSave: isSave,
            userId:userId
        };
    } else {
        workdayObj = {
            certifyByAdmin:certifyByAdmin,
            changes: changes,
            workdayId: workday.WorkDay_Id,
            role: role,
            demp_display_id:workday.demp_display_id,
            duty_activity: workday.duty_activity,
            wdy_spread_adjust : totalTOS,
            wdy_working_time_hos_adjust : totalHOS,
            wdy_time_end:wdy_time_end,
            wdy_date:wdy_date,
            dutyActivityStatus: workday.dutyActivityStatus,
            isSave: isSave,
            userId:userId
        };
    }
    workdayObj.restbreak_no = workday.restbreak_no;
    workdayObj.job_type = workday.job_type;
    workdayObj.job_class = workday.job_class;
    workdayObj.wdy_job_symbol = workday.wdy_job_symbol;
    //place start end time start and end for work day
    workdayObj.wdy_place_start = workday.wdy_place_start;
    workdayObj.wdy_place_end = workday.wdy_place_end;
    workdayObj.wdy_time_end = moment(workday.wdy_time_end, "MM/DD/YYYY hh:mm A").format("YYYY-MM-DD HH:mm");
    workdayObj.wdy_time_start = moment(workday.wdy_time_start, "MM/DD/YYYY hh:mm A").format("YYYY-MM-DD HH:mm");
    workdayObj.from_web = 1;
    workdayObj.dty_act_series_6 = workday.dty_act_series_6;
    workdayObj.dty_act_series_14 = workday.dty_act_series_14;
    workdayObj.AmendmentNo = workday.AmendmentNo;
    workdayObj.IsAmendment = workday.IsAmendment;
    workdayObj.isSeriesUpdated = workday.series_14_updated === true ? true : false;
    workdayObj.employeeId = workday.demp_display_id;
    workdayObj.previous_Time_Off_Duty = workday.previous_Time_Off_Duty;
    workdayObj.relieved_Of_Duty=workday.relieved_Of_Duty;
    workdayObj.final_Release=workday.final_Release;
    workdayObj.total_time_hos=workday.total_time_hos;
    workdayObj.previous_Non_CoveredService_date=workday.previous_Non_CoveredService_date;
    
    let commentTime = moment().format('L') + " " + moment().format('LT');
    return (dispatch, getState) => {
        const state = getState();
        const token = state.authState.api_token;       
        let adminUserName =  state.authState.userName.split('@');       
        let certifyUserName = state.authState.impersonateUserId>0?  adminUserName[0].replace('.',' '):state.authState.name;

        workdayObj.certifyUserName = certifyUserName;
        if(comments.value){
            workdayObj.comments = certifyUserName + " (" + commentTime + ")" + " ^- " + comments.value + "~";
        }
        else{
            workdayObj.comments = '';
        }
        if(workdayObj.duty_activity){ 
            let dutyActivity = workdayObj.duty_activity;
            let adjustedActivity = dutyActivity.map(activity => {
                activity.dty_act_name = activity.dty_act_name_updated ? activity.dty_act_name_updated : activity.dty_act_name;
                if(activity.dty_act_end_time){
                   let endTime = activity.dty_act_end_time_updated ? activity.dty_act_end_time_updated.toUpperCase() :  activity.dty_act_end_time.toUpperCase();
                   activity.dty_act_end_time = moment(endTime, "hh:mm A").format('hh:mm A');
                }
                if(activity.dty_act_start_time){
                   let startTime = activity.dty_act_start_time_updated ? activity.dty_act_start_time_updated.toUpperCase() : activity.dty_act_start_time.toUpperCase();
                   activity.dty_act_start_time = moment(startTime, "hh:mm A").format('hh:mm A');
                }
                if(activity.dty_act_end_time_updated){
                   activity.dty_act_end_time_updated =  activity.dty_act_end_time_updated.toUpperCase();
                }
                if(activity.dty_act_start_time_updated){
                   activity.dty_act_start_time_updated = activity.dty_act_start_time_updated.toUpperCase();
                }              
                if(activity.dty_adjusted_value_updated == null || activity.dty_adjusted_value_updated == "00:00"){
                    activity.dty_adjusted_value_updated = "0:00"
                }
                if(activity.dty_adjusted_value == "00:00"){
                    activity.dty_adjusted_value = "0:00"
                }
                activity.dty_act_start_date = activity.dty_act_start_date? activity.dty_act_start_date : wdy_date;
                activity.dty_act_end_date = activity.dty_act_end_date ? activity.dty_act_end_date : wdy_date;
            });
            workdayObj.duty_activity = dutyActivity;
        }    
        dispatch(actionInProcess(true));
        fetch(url, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(workdayObj)
        })
        .then((response) => response.json())
        .then((data) => { 

            let fetchObj = {};
            if(data.success) {
                dispatch(notificationSuccess(notifyObj));
                setTimeout(function(){
                    dispatch(hideNotification())
                }, 3000);
                dispatch(actionInProcess(false));
                let fetchObj = {
                    certifyStatus:localStorage.getItem('route')
                };
                dispatch(hideModal_Success(false, 'Certify_Modal'));
                dispatch(setDefaultWorkdaySuccess({}));
                fetchObj.role = 'emp';
                fetchObj.url = "/userhoslogs";
                fetchObj.source = 'web';
                fetchObj.pageNum = 1;  
                fetchObj.empId = localStorage.getItem('empId');   
                fetchObj.startDate= inputParam.historicalStartDate? inputParam.historicalStartDate:'';
                fetchObj.endDate= inputParam.historicalEndDate?inputParam.historicalEndDate:'';

                dispatch(fetchhoslogsWorkdays(fetchObj));

            } else {
                dispatch(activity_err_success(true, false, data.message || data.errMsg, true ));
                dispatch(actionInProcess(false));
            }
        }) 
        .catch((error) => {
            console.log(error);
            dispatch(actionInProcess(false));
        });
    };
}
//FRA report
//to get hos logs for admin
export function fetchfralogsWorkdays(fetchObj, callback) {

    let route = fetchObj.route ? fetchObj.route:undefined;
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(printProgress(false));
        dispatch(showLoading());
        dispatch(workdaysIsLoading(true));
        dispatch(coverLoading(true));
        fetch(url + uniqueUrl, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(fetchObj),
            // signal: fetchController.signal
        }).then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(workdaysIsLoading(false));
                dispatch(coverLoading(false));
                dispatch(hideLoading());
                return response;
            })
           .then(response =>
                response.json().then(items => ({ items, response }))
                    ).then(({ items, response }) =>  {
                if (!response.ok) {
                  // If there was a problem, we want to
                  // dispatch the error condition
                  dispatch(workdaysIsLoading(false));
                  dispatch(hideLoading());
                  dispatch(coverLoading(false));
                  return Promise.reject(items)
                } else {
                    dispatch(fraFetchDataSuccess(items));
                    dispatch(hideLoading());
                    dispatch(coverLoading(false));
                    if(callback){
                        callback(items);
                    }                    
                }
            })
            .catch(err => {
                console.log(err);
                dispatch(workdaysIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
            });
    };
}

export const fraFetchDataSuccess = (workdays) => (dispatch) => {  
    dispatch({
        type: actionTypes.ITEMS_SUCCESS,
        workdays: workdays.workdays,
        pageNum: workdays.pageNum,
        activities:workdays.activities,
        locations:workdays.locations,
        filteractivities : workdays.filteractivities 
    })
    //TODO : should get role and route from sp for rolesuccess
    dispatch(roleSuccess(workdays));
    dispatch(paginationSuccess(workdays));
}

//to get hos logs details for particular log
export function getFRADetailsAction(url, callback) {
    var url = url + "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(workdayIsLoading(true));
        dispatch(fraWorkdayIsLoading(true));
        dispatch(showLoading());
        fetch(url,{
            method: 'GET',
            headers:getHeaders(token)
        })
        .then((response) => {
            if (!response.ok) {
                manageError(dispatch, response);
                throw Error(response.statusText);
            }
            dispatch(workdayIsLoading(false));  
            dispatch(hideLoading());
            if(callback){
                callback(response);
            }
            return response;
        })
        .then((response) => response.json())
        .then((workdays) => {
            dispatch(getFRAWorkdaySuccess(workdays));
            dispatch(hideLoading());
            if(callback){
                callback(workdays);
            }
        })
    };
}

function getFRAWorkdaySuccess(workdays) {
    return {
        type: actionTypes.FRA_WORKDAY_SUCCESS,
        workdays
    };
}
function fraWorkdayIsLoading(bool) {
    return {
        type: actionTypes.FRA_WORKDAY_LOADING,
        isLoading: bool
    }
}

function seriesIsLoading(bool) {
    return {
        type: actionTypes.SERIES_IS_LOADING,
        isLoading: bool
    }
}
export function getWorkdaySeriesAction(fetchObj, callback) {   
    // if(fetchController != null){
    //     fetchController.abort();
    //     fetchController = null;
    // }
    // fetchController = new AbortController();
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    let isSeries_14filter = fetchObj.filter_14,isSeries_6filter = fetchObj.filter_6;
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(coverLoading(true));
        dispatch(printProgress(false));
        dispatch(showLoading());
        dispatch(seriesIsLoading(true));
        fetch(url + uniqueUrl, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(fetchObj),
            // signal: fetchController.signal
        }).then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(seriesIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                return response;
        })
        .then(response =>
            response.json().then(items => ({ items, response }))
                ).then(({ items, response }) =>  {
            if (!response.ok) {
                dispatch(seriesIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                return Promise.reject(items)
            } else {
                let workdays = items.workdays.filter((i) => {
                    return  (isSeries_14filter ? i["14_day_series"] > 14 : true) && 
                                (isSeries_6filter ? i["6_day_series"] > 6 : true)
                });
                dispatch(seriesFetchDataSuccess(workdays));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                if(callback){
                    callback(items);
                }                    
            }
        })
        .catch(err => {
            console.log(err);
            dispatch(hideLoading());
            dispatch(seriesIsLoading(false));
            dispatch(coverLoading(false));
        });
    };
}
export const seriesFetchDataSuccess = (workdays) => (dispatch) => {  
    dispatch({
        type: actionTypes.SERIES_WORKDAY_SUCCESS,
        workdays: workdays
    })
    
    dispatch(roleSuccess(workdays));
    //dispatch(paginationSuccess(workdays));
}

//Series 14 Action
export function getWorkdaySeries14Action(fetchObj, callback) {   
    
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        dispatch(coverLoading(true));
        dispatch(printProgress(false));
        dispatch(showLoading());
        dispatch(seriesIsLoading(true));
        fetch(url + uniqueUrl, {
            method: 'POST',
            headers:postHeaders(token),
            body: JSON.stringify(fetchObj),
            // signal: fetchController.signal
        }).then((response) => {
                if (!response.ok) {
                    manageError(dispatch, response);
                    throw Error(response.statusText);
                }
                dispatch(seriesIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                return response;
        })
        .then(response =>
            response.json().then(items => ({ items, response }))
                ).then(({ items, response }) =>  {
            if (!response.ok) {
                dispatch(seriesIsLoading(false));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                return Promise.reject(items)
            } else {
                dispatch(series14FetchDataSuccess(items));
                dispatch(hideLoading());
                dispatch(coverLoading(false));
                if(callback){
                    callback(items);
                }                    
            }
        })
        .catch(err => {
            console.log(err);
            dispatch(hideLoading());
            dispatch(seriesIsLoading(false));
            dispatch(coverLoading(false));
        });
    };
}
export const series14FetchDataSuccess = (workdays) => (dispatch) => {  
    dispatch({
        type: actionTypes.SERIES_WORKDAY_SUCCESS,
        workdays: workdays.workdays,
        pageNum: workdays.pageNum
    })
    dispatch(paginationSuccess(workdays));
}

export function getEmployeeList(url,callback) { 
    let urlGet = url + "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        fetch(urlGet, {
            method: 'GET',
            headers:getHeaders(token),
        })
        .then((response) => {
            if (!response.ok) {
                manageError(dispatch, response);
                throw Error(response.statusText);
            }
            dispatch(hideLoading());
            return response;
        })
        .then(response => response.json().then(items => ({ items, response })))
        .then(({ items, response }) =>  {
            if (!response.ok) {
                return Promise.reject(items)
            } else {
                dispatch({
                    type: actionTypes.EMPLIST_SUCCESS,
                    employees : items
                });
                if(callback){
                    callback(items);
                }                  
            }
        });
    };
}
export const updateSidebarmenuToggle = (type) => (dispatch, getState) => {  
    const state = getState();
    let isPay,isLog,isAlert,isOther;
    if(type == "pay"){
        isPay = !state.configurations.showPayMenu,isLog = false,isOther = false,isAlert = false;
    }
    else if(type == "log"){
        isPay = false,isLog = !state.configurations.showLogMenu,isOther = false,isAlert = false;
    }
    else if(type == "alert"){
        isPay = false,isAlert = !state.configurations.showAlertMenu,isOther = false,isLog = false;
    }
    else{
        isPay = false,isLog = false,isOther = !state.configurations.showOtherMenu,isAlert = false;
    }
    dispatch({
        type: actionTypes.UPDATE_TOGGLE_SIDEBARMENU,
        showPayMenu : isPay,
        showLogMenu : isLog,
        showOtherMenu : isOther,
        showAlertMenu : isAlert
    })
}

export function getPDF(fetchObj,callback) { 
    let isPdfAvailable = true;
    let url = fetchObj.url,
        uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        const token = getState().authState.api_token;
        fetch(url + uniqueUrl,{
            method: 'GET',
            headers:getHeaders(token),
        })
        .then((response) => {
            if (!response.ok) {
                manageError(dispatch, response);
                throw Error(response.statusText);
            }
            return response;
        })
        .then(response => response.json())
        .then((response) =>  {
            if (response.success == true) {
                isPdfAvailable = true;
            } else {
                isPdfAvailable = false;
            }
            callback(isPdfAvailable);  
        });
    };
}
function hideDeadheadWarning() {
    return {
        type:actionTypes.DEADEHEAD_WARNING,
        warning:false,
        warningMessage:''
    }
}
function showDeadheadWarning(status, message) {
    return {
        type:actionTypes.DEADEHEAD_WARNING,
        warning:status,
        warningMessage:message
    }
}
export const setDeadheadWarningAction = (status, message) => (dispatch) =>{
    dispatch(showDeadheadWarning(status, message));
}

export const setAzureMsal = (msal) => (dispatch) => {
    dispatch({
        type: actionTypes.SET_AZURE_MSAL,
        msal: msal
    });
};
export const setAzureUserAcc = (user) => (dispatch) => {
    dispatch({
        type: actionTypes.SET_AZURE_USER_ACC,
        user: user
    });
};

export const SetHomePath = (path) => (dispatch) => {
    
    dispatch({
        type: actionTypes.SET_HOME_PATH,
        path: path
    });
};

export const SetAzureLoginError = (message) => (dispatch) => {
    dispatch({
        type: actionTypes.SET_AZURE_ERROR,
        message: message
    });
};

// Impersonate Login start

export function loginforImpersonateUser()
{
    return (dispatch) => {
        localStorage.clear();
        dispatch(impersonateLoginStart());        
    }
}

function impersonateLoginStart(){
    if(logout_timer){
        clearTimeout(logout_timer);
    } 
    if(logout_interval){
        clearInterval(logout_interval);
    }
    return {
        type:actionTypes.IMPERSONATE_LOGIN_START,
        authenticated:false,
        role:'',
        name:'',
        employeeID:'',
    }
}

export function getImpersonateEmpName(url,callback) { 
    let uniqueUrl = "?_= " + new Date().getTime();
    return (dispatch,getState) => {
        
       const token = getState().authState.api_token;
       

        fetch(url + uniqueUrl,{
            method: 'GET',
            headers:getHeaders(token),
        }) 
        .then((response) => {
            if (!response.ok) {
                manageError(dispatch, response);
                throw Error(response.statusText);
            }
            return response;
        })
        .then(response => response.json())
        .then((response) =>  {
            callback(response); 
        });
    };
}

export function impersonateLoginSuccess(state, message) {
    return (dispatch,getState) => {
        if(state == "LoginProgress"){
            dispatch(loginInProgress(true));
        } else if(state == "LoginError"){
            dispatch(loginInProgress(false));

            dispatch(loginError(message));
            localStorage.clear();
        } else if(state == "LoginSuccess"){


            dispatch(loginSuccess(message));
            localStorage.setItem("impersonateUserId", message.impersonateUserId);
        }
    };
}
//Impersonate login ends

